module.exports = __webpack_public_path__ + "static/media/20240130084106_IMG_5079 (1).90a4b36b.jpg";